import { useState } from "react";
import { Printer, FileText, Ban, Bluetooth } from "lucide-react";
import { printSale } from "@/pos/lib/print";
import { toast } from "sonner";
import { api, useApi, errMsg } from "@/pos/lib/api";
import { useAuth } from "@/pos/context/AuthContext";
import { rm, dt, todayStr, METHOD_LABEL } from "@/pos/lib/format";
import { Page, PageHeader, Empty } from "@/pos/components/Common";
import DateRange from "@/pos/components/DateRange";

export default function Sales() {
  const [range, setRange] = useState([todayStr(), todayStr()]);
  const { data, reload } = useApi("/sales", { date_from: range[0], date_to: range[1] });
  const { isOwner } = useAuth();
  const sales = data || [];
  const done = sales.filter((s) => s.status === "selesai");

  const voidSale = async (s) => {
    if (!window.confirm(`Batalkan resit ${s.number}? Jualan akan ditanda BATAL dan order dibuka semula (belum bayar).`)) return;
    try {
      await api.post(`/sales/${s.id}/void`);
      toast.success("Jualan dibatalkan");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Page>
      <PageHeader title="Senarai Jualan" subtitle={isOwner ? "Bil, invois & resit" : "Bil hari ini – cetak semula resit"} />
      {isOwner && <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <DateRange value={range} onChange={setRange} />
        <div className="font-mono text-sm" data-testid="sales-summary">{done.length} jualan · <b>{rm(done.reduce((a, s) => a + s.total, 0))}</b></div>
      </div>}
      <div className="card-surface overflow-x-auto">
        <table className="data-table" data-testid="sales-table">
          <thead><tr><th>No.</th><th>Tarikh</th><th>Pelanggan</th><th>Item</th><th>Bayaran</th><th className="text-right">Jumlah</th><th></th></tr></thead>
          <tbody>
            {sales.map((s) => (
              <tr key={s.id} className={s.status === "batal" ? "opacity-50" : ""} data-testid={`sale-row-${s.number}`}>
                <td className="font-mono font-semibold">{s.number}{s.status === "batal" && <span className="ml-2 rounded bg-rose-100 px-1.5 text-[10px] text-rose-600">BATAL</span>}</td>
                <td className="whitespace-nowrap text-slate-500">{dt(s.created_at)}</td>
                <td>{s.customer_name || "Umum"}</td>
                <td className="text-slate-500">{s.items.map((i) => i.name).join(", ")}</td>
                <td>{METHOD_LABEL[s.payment_method]}</td>
                <td className="text-right font-mono font-bold">{rm(s.total)}</td>
                <td className="whitespace-nowrap text-right">
                  <button title="Cetak Bluetooth" className="icon-btn" onClick={() => printSale(s)} data-testid={`sale-bt-print-${s.number}`}><Bluetooth size={16} /></button>
                  <button title="Resit" className="icon-btn" onClick={() => window.open(`/pos/cetak/resit/${s.id}`, "_blank")} data-testid={`sale-receipt-${s.number}`}><Printer size={16} /></button>
                  <button title="Invois A4" className="icon-btn" onClick={() => window.open(`/pos/cetak/invois/${s.id}`, "_blank")} data-testid={`sale-invoice-${s.number}`}><FileText size={16} /></button>
                  {s.status === "selesai" && <button title="Batal Resit" className="icon-btn hover:text-rose-600" onClick={() => voidSale(s)} data-testid={`sale-void-${s.number}`}><Ban size={16} /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {sales.length === 0 && <Empty text="Tiada jualan dalam tempoh ini" />}
      </div>
    </Page>
  );
}
